const launchScriptUrls = {
  prod: "https://assets.adobedtm.com/697d0c070f1e/ea551cf1cad8/launch-5d99fead16ce.min.js",
  nonProd:
    "https://assets.adobedtm.com/697d0c070f1e/ea551cf1cad8/launch-eb6ceb729916-staging.min.js",
};

export default launchScriptUrls;
